import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfirmDialogService } from '../services/confirm-dialog.service';
import { SessionTimeoutService } from '../services/session-timeout.service';
import { AuthService } from '../auth.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
  /** Optional (the Architect, 2026-09-27): reverts the in-editor view back to the last
   *  loaded/saved snapshot. Called below when the Analyst confirms "leave without
   *  saving" -- without this, the shared dataTransformConfigViewModel object stayed
   *  mutated by whatever unsaved edit prompted the warning (Reset Transformer being the
   *  most drastic example) even after the Analyst declined to keep it. Optional so any
   *  future component implementing this interface without the base class still
   *  compiles; the guard simply skips the revert for it. */
  revertToSnapshot?: () => void | Promise<void>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private confirmDialogService: ConfirmDialogService,
    private sessionTimeoutService: SessionTimeoutService ,// Inject SessionTimeoutService
    private authService: AuthService
  ) {}
  async canDeactivate(component: ComponentCanDeactivate):  Promise<boolean> {//: boolean | Observable<boolean>
    // if there are no pending changes, just allow deactivation; else confirm first
    // return component.canDeactivate() ?
    //   true :
      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      // see http://stackoverflow.com/a/42207299/7307355
      //confirm('WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
      // confirm('The Transformer Configuration has not been saved, leave page without saving?');
      if(component.canDeactivate())
        return true;
      else{

        if (this.authService.getLoginStatus()) {
          const dialogRef = this.confirmDialogService.openConfirmDialog('The Transformer Configuration has not been saved.<br>Leave page without saving?');
          const result = await dialogRef.afterClosed().toPromise();
          if (result) {
            // Confirmed "leave without saving" -- actually discard the unsaved edit
            // from the shared view model before allowing navigation (the Architect,
            // 2026-09-27). See ComponentCanDeactivate.revertToSnapshot for why this is
            // needed at all.
            await component.revertToSnapshot?.();
          }
          return result;
        }
        else
        {
          return true;
        }
        

       
      }
  }
}